import clsx from "clsx";
import type * as React from "react";
import { useFormContext } from "react-hook-form";
import type { ZodString } from "zod";

interface FormTextAreaProps {
	formKey: string;
	schema: ZodString;
	className?: string;
}

const FormTextArea: React.FC<FormTextAreaProps> = ({
	formKey,
	schema,
	className,
}) => {
	const { register } = useFormContext();

	return (
		<textarea
			id={formKey}
			placeholder={schema.description || ""}
			className={clsx(
				"laptop:w-96 w-full resize-none shadow shadow-slate-100 dark:bg-slate-700 dark:shadow-slate-900",
				className,
			)}
			rows={3}
			{...register(formKey, {
				valueAsNumber: false,
				setValueAs: (v) => (v.trim() === "" ? undefined : v),
			})}
		/>
	);
};

export default FormTextArea;
